
import React, { Fragment, useEffect, useState } from "react";
import Breadcrumb from "../../common/breadcrumb";
import { Modal, Button, Card, CardBody, CardHeader, Col, Container, Form, FormGroup, Input, Label, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
//import EditBrand from "./EditBrand";
import { useDispatch, useSelector } from "react-redux";
import { DeleteBrand, GetBrand } from "../../../redux/actions/productActions";
import DataTables from "../../common/DataTables";
import { toast } from 'react-toastify';
import { RESET_ERROR } from "../../../redux/constants/userConstants";
import DataTable from "react-data-table-component";
import SearchHeader from "../../common/header_components/searchHeader";
import AddBrands from "./AddBrands";
import moment from "moment";
import Reactotron from "reactotron-react-js"

const Brands = () => {
    const dispatch = useDispatch()
    const [datas, setDatas] = useState([])
    const { getbrandlist, branddelsuccess, editedbrand, newbrand, error } = useSelector(state => state.product)
    const [open, setOpen] = useState(false);
    const [openedit, setOpenEdit] = useState(false);
    const [activeData, setActiveData] = useState(null)
    const [title, setTitle] = useState('')
    const [filterText, setFilterText] = useState('');

    Reactotron.log(getbrandlist, "daadgetbrandlista")

    const customToast = "delB";
    const customCToast = "delBr";
    const customUToast = "delBran";

    const Capitalize = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };


    const handleDelete = (id) => {
        if (window.confirm("Are you sure you wish to delete this brand?")) {
            dispatch(DeleteBrand(id))
        }


    }

    const handleEdit = (data) => {
        setTitle("Edit Diecast Brand");
        setActiveData(data)
        setOpen(true)

    }

    const onOpenModal = () => {
        setTitle('Add Diecast Brand')
        setActiveData(null)
        setOpen(true);
    };

    const onCloseModal = () => {
        setOpen(false);
    };
    const onOpenEditModal = () => {
        setOpenEdit(true);
    };

    const onCloseEditModal = () => {
        setOpenEdit(false);
    };
    useEffect(() => {
        dispatch(GetBrand())
    }, [])

    useEffect(() => {
        if (getbrandlist) {
            setDatas(getbrandlist)
        }
    }, [getbrandlist])

    useEffect(() => {
        if (branddelsuccess) {
            toast.success("Diecast Brand Deleted Successfully", { toastId: customToast });
            dispatch({
                type: RESET_ERROR
            })
        } else {
            toast.error(error)
        }

    }, [branddelsuccess])


    useEffect(() => {
        if (newbrand) {
            toast.success("Diecast Brand Created Successfully", { toastId: customCToast });
            dispatch({
                type: RESET_ERROR
            })
            setActiveData(null);
            setOpen(false);
            setTitle('')
        }

    }, [newbrand])


    useEffect(() => {
        if (editedbrand) {
            toast.success("Diecast Brand Updated Successfully", { toastId: customUToast });
            dispatch({
                type: RESET_ERROR
            })
            setActiveData(null);
            setOpen(false);
            setTitle('')

        }

    }, [editedbrand])


    useEffect(() => {
        if (error) {
            toast.error(`${error.message}`);
            dispatch({
                type: RESET_ERROR
            })
        }
    }, [error])

    var columns = [
        {
            name: <b>{Capitalize("S.No")}</b>,
            header: <b>{Capitalize("S.No")}</b>,
            cell: (row, index) => index + 1
        },
        {
            name: <b>{Capitalize("Created At")}</b>,
            header: <b>{Capitalize("Created At")}</b>,
            cell: (row, index) => moment(row?.created_at).format('DD-MM-YYYY hh:mm A')
        },
        {
            name: <b>{Capitalize("Diecast Brand Name")}</b>,
            header: <b>{Capitalize("Diecast Brand Name")}</b>,
            selector: row => row?.name,
            style: {
                textAlign: "center",
            },
        },
        {
            name: <b>{Capitalize("Image")}</b>,
            header: <b>{Capitalize("Image")}</b>,
            cell: (row, index) => (

                <>
                    <span>
                        <img style={{ width: 50, height: 50 }} src={row?.logo}></img>
                    </span>
                </>

            )
        },
        {
            name: <b>Actions</b>,
            id: "delete",
            accessor: (str) => "delete",
            cell: (row, index) => (

                <>
                    <span onClick={() => handleDelete(row._id)} >

                        <i
                            className="fa fa-trash"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "#e4566e",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                    <span onClick={() => handleEdit(row)}>
                        <i
                            className="fa fa-pencil"
                            style={{
                                width: 35,
                                fontSize: 20,
                                padding: 11,
                                color: "rgb(40, 167, 69)",
                                cursor: "pointer"
                            }}
                        ></i>
                    </span>
                </>
            )
        }
    ];

    const subHeaderComponentMemo = React.useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setFilterText('');
            }
        };

        return (
            <div style={{ display: 'flex', justifyContent: 'flex-end', flex: 1 }}>
                <SearchHeader onFilter={e => setFilterText(e.target.value)} onClear={handleClear} filterText={filterText} />
            </div>
        );
    }, [filterText]);

    useEffect(() => {
        // if(filterText){
        let datas = getbrandlist?.filter(cat => cat?.name?.toLowerCase().includes(filterText?.toLowerCase()))
        setDatas(datas)
        // }
    }, [filterText])

    return (
        <Fragment>
            <Breadcrumb title="Diecast Brands" parent="Products" />
            {/* <!-- Container-fluid starts--> */}
            <Container fluid="true">
                <Row>
                    <Col sm="12">
                        <Card>
                            <CardHeader>
                                <h5>Diecast Brands</h5>
                            </CardHeader>
                            <CardBody>
                                <div className="btn-popup pull-right">
                                    <Button
                                        type="button"
                                        color="secondary"
                                        onClick={onOpenModal}
                                        data-toggle="modal"
                                        data-original-title="test"
                                        data-target="#exampleModal"

                                    >
                                        Add Diecast Brand

                                    </Button>

                                </div>
                                <div className="clearfix"></div>
                                <div id="basicScenario" className="product-physical">
                                    <DataTable
                                        pagination columns={columns}
                                        data={datas}
                                        fixedHeader
                                        subHeader
                                        subHeaderComponent={subHeaderComponentMemo}
                                    />

                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
            <AddBrands
                openModal={open}
                onCloseModal={() => {
                    setActiveData(null)
                    setOpen(false)
                }}
                data={activeData}
                setActiveData={setActiveData}
                title={title}
            />


        </Fragment>
    )
}

export default Brands